import { ServerStock } from '@/lib/janitsjar/Product';
import { useCurrentStoreStock } from '@/cataloguePages/productPageWithVariants/helpers';
import ProductStatus from '@/cataloguePages/productPageWithVariants/components/ProductStatus';

type ProductStatusCollectProps = {
  stock: ServerStock;
};

export default function ProductStatusCollect({
  stock,
}: ProductStatusCollectProps) {
  const title = 'Klikk & Hent';
  const storeStock = useCurrentStoreStock(stock);

  if (!storeStock) return null;

  if (!storeStock.availableToOrder && storeStock.stock < 1) {
    return (
      <ProductStatus
        name={title}
        badgeVariant="primaryDark"
        badgeText={storeStock.reasonText ?? 'Utsolgt'}
      />
    );
  }

  if (storeStock.stock < 1) {
    return (
      <ProductStatus
        name={title}
        badgeVariant="primaryDark"
        badgeText="Ikke tilgjengelig i butikk"
      />
    );
  }

  return (
    <ProductStatus
      name={title}
      badgeVariant="successDark"
      // badgeText={`${storeStock.stock} på lager i ${storeStock.storeName}`}
      badgeText="Tilgjengelig"
    />
  );
}
